'use client';

import { useEffect, useState } from 'react';
import {
    loadWebReviewsDisplayEnabled,
    type WebReviewsDisplayScreen,
} from '@/hotdesk-ui/helpers/web-reviews-display';

/**
 * Client hook: whether to show rating UI on a given surface.
 * Localhost starts enabled to avoid badge flash; prod starts off until RC resolves.
 */
export function useWebReviewsDisplay(
    screen: WebReviewsDisplayScreen
): boolean {
    const [enabled, setEnabled] = useState(() => {
        if (typeof window === 'undefined') return false;
        const host = window.location.hostname;
        return host === 'localhost' || host === '127.0.0.1';
    });

    useEffect(() => {
        let cancelled = false;
        loadWebReviewsDisplayEnabled(screen)
            .then((value) => {
                if (!cancelled) setEnabled(value);
            })
            .catch(() => {
                if (!cancelled) setEnabled(false);
            });
        return () => {
            cancelled = true;
        };
    }, [screen]);

    return enabled;
}
